import {combineReducers} from 'redux';

export default combineReducers({
    domain: (state = {}) => state,
    experiments: (state = {}) => state,
    featureFlags: (state = {}) => state,
    isMobile: (state = {}) => state,
});
